import React, { PureComponent, PropTypes } from 'react';
import { dragSource } from '../decorators';

class ColumnIcon extends PureComponent {
    constructor(...props) {
        super(...props);
        this.state = {};
        this.offset = {x: 0, y: 0};
    }

    static propTypes = {
        label: PropTypes.string.isRequired
    }

    render() {
        const { placeholder, label } = this.props;

        return <div>{label || placeholder }</div>;
    }
}


export default dragSource(ColumnIcon, 'column-icon');


// WEBPACK FOOTER //
// ./src/components/importer/columnicon.js